import { useMutation } from 'react-query';
import { UpdatePasswordPayload, timefitBackend } from '../../../Shared/Services/TimefitBackend';

export function useUpdatePassword() {
  const mutation = (payload: UpdatePasswordPayload) => {
    return timefitBackend.updatePassword(payload);
  };
  return useMutation(mutation);
}
